import React, { FunctionComponent } from 'react';
import { Form } from '@visalex/forms';
import { useFormContext } from 'react-hook-form';

import { TFunction } from 'i18next';

import { createCaption } from './Caption';

import styles from '../../Common/QuestionnairesCommon.module.scss';

export const FreeConsultationRadio: FunctionComponent<{
  t: TFunction;
  fieldName: string;
  index: number;
}> = ({ t, fieldName, index }) => {
  const { setValue } = useFormContext();

  return (
    <Form.RadioGroup
      inline
      name={fieldName}
      helper={createCaption(index, t)}
      onChange={(newValue) => setValue(fieldName, newValue, { shouldValidate: true })}
      className={styles.questionnaire__radio}
      rules={{ validate: (newValue: string) => newValue && newValue === 'no' }}
      options={[
        { label: t('common.yes'), value: 'yes' },
        { label: t('common.no'), value: 'no' },
      ]}
    />
  );
};
